import { Link } from "react-router-dom";
import { genres } from "@/mocks/genres";

export default function CategoryQuickEntry() {
  return (
    <section className="w-full max-w-[1360px] mx-auto px-4 md:px-6 -mt-10 md:-mt-14 relative z-20">
      <div className="rounded-lg bg-background-50 border border-background-200 p-4 md:p-6">
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-2.5">
            <span className="w-1.5 h-5 rounded-full bg-accent-500"></span>
            <h2 className="text-base md:text-lg font-heading font-bold text-foreground-950">快速分类入口</h2>
          </div>
          <span className="text-xs text-foreground-500 hidden sm:block">按类型快速找到想看的电影</span>
        </div>
        <div className="grid grid-cols-3 md:grid-cols-5 lg:grid-cols-9 gap-2 md:gap-3">
          {genres.map((g) => (
            <Link
              key={g.slug}
              to={`/category/${g.slug}`}
              title={`${g.label}电影 - 最新电影`}
              className="group flex flex-col items-center gap-2 py-3 md:py-4 rounded-lg bg-background-100 hover:bg-primary-500 transition-colors cursor-pointer"
            >
              <span className="w-10 h-10 flex items-center justify-center rounded-full bg-background-50 text-accent-500 group-hover:bg-primary-600 group-hover:text-secondary-300 transition-colors">
                <i className={`${g.icon} text-xl`}></i>
              </span>
              <span className="text-xs md:text-sm font-medium text-foreground-800 group-hover:text-background-50 transition-colors">
                {g.label}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}